
import Vue from 'vue'

export default Vue.extend({
   name: 'ClickToSelectList',
   props: {
      selected: { type: Array as () => string[], default: () => [] },
      options: { type: Array as () => NameValuePair[], default: () => [] },
      max: { type: Number, default: 0 },
      selectedLabel: { type: String, default: 'Selected' },
      unselectedLabel: { type: String, default: 'Unselected' },
      selectLabel: { type: String, default: 'Click to select' },
      deselectLabel: { type: String, default: 'Click to deselect' },
   },
   data() {
      return {
         schoolitemOptions: [] as NameValuePair[],
      }
   },
   computed: {
      itemsInGroup(): NameValuePair[] {
         if (this.options.length === 0) {
            return []
         }
         return this.selected.map(
            selectedId => this.options.find(opt => opt.value === selectedId) as NameValuePair
         )
      },
      itemsNotInGroup(): NameValuePair[] {
         if (this.options.length === 0) {
            return []
         }
         return this.options.filter(opt => !this.selected.includes(opt.value as string))
      },
      selectionIsFull(): boolean {
         return this.itemsInGroup.length >= this.max
      },
   },
   methods: {
      add(item: NameValuePair) {
         if (this.selectionIsFull) {
            return
         }

         if (!this.selected.includes(item.value as string)) {
            this.selected.push(item.value as string)
         }
      },
      remove(item: NameValuePair) {
         if (this.selected.includes(item.value as string)) {
            this.selected.splice(this.selected.indexOf(item.value as string), 1)
         }
      },
   },
})
